<script>
export default {
  data() {
    return {
      masks: {
        phoneMask: "(###) ###-####",
        sapMask: "##########"
      },
      rules: {
        required: value => value === 0 || !!value || "Required.",
        inches: val => {
          const pattern = /^([0-9]|0[0-9]|1[0-1])$/;
          return !val || pattern.test(val) || "Must be 0-11";
        },
        zipCode: (countryCode, zipCode) => {
          let pattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

          if (countryCode === "US") {
            return pattern.test(zipCode) || "##### OR #####-####";
          } else {
            pattern = /(^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$)/;
            return pattern.test(zipCode) || "XXX XXX";
          }
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return !value || pattern.test(value) || "Invalid e-mail.";
        },
        phoneNumber: value => {
          if (value) {
            return value.length === 14 || "(555) 555-5555";
          } else return true;
        },
        sapDocumentNumberStartWith: val => {
          const pattern = /(^18)/;
          return !val || pattern.test(val) || "Must start with 18";
        },
        sapDocumentNumberLength: val => {
          const pattern = /(^[0-9]{10})$/;
          return !val || pattern.test(val) || "Must have 10 numbers";
        },
        amountPayingLowLimit: val => {
          let newValueMod = val.replace("$ ", "").replace(",", "");
          let num = Number.parseFloat(newValueMod);
          return num > 0.0 || "Amount must be greater then $ 0.00";
        },
        amountPayingOverLimit: isOverLimit => {
          return isOverLimit || "Over payment is not allowed";
        }
      }
    };
  },
  methods: {
    ceilingRounding(number, decimals) {
      const factor = Math.pow(10, decimals);
      return Math.ceil(number * factor) / factor;
    },
    formatPrice(amount, isNegative) {
      let val = amount.toFixed(2);
      let returnVal = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (isNegative) {
        returnVal = "$ - " + returnVal;
      } else {
        returnVal = "$ " + returnVal;
      }
      return returnVal;
    },
    keydownAllowNumberOnly(event) {
      if (this.isLeftUpRightDownBackspaceDeleteTab(event.keyCode)) {
        return;
      }

      let regex = /[0-9]/;

      if (!regex.test(event.key)) {
        event.preventDefault();
        return false;
      }
    },
    allowAlphanumericOnly(event) {
      var blockSpecialCharacterRegex = /^[a-z0-9\s]+$/i;
      var key = String.fromCharCode(
        !event.charCode ? event.which : event.charCode
      );
      if (!blockSpecialCharacterRegex.test(key)) {
        event.preventDefault();
        return false;
      }
    },
    isReturnKey(event) {
      return event.keyCode === 13;
    },
    isLeftUpRightDownBackspaceDeleteTab(keyCode) {
      return (
        keyCode === 37 ||
        keyCode === 38 ||
        keyCode === 39 ||
        keyCode === 40 ||
        keyCode === 8 ||
        keyCode === 46 ||
        keyCode === 9
      );
    },
    appendHyphenAtSecondIndex(value) {
      const maskedValue = value.replace(/(\d{2})(\d{7})/, "$1-$2");
      return maskedValue;
    },
    appendHyphenAtFifthIndex(value) {
      const maskedValue = value.replace(/(\d{5})(\d{4})/, "$1-$2");
      return maskedValue;
    },
    numberToStringWithComma(value, decimals) {
      let newValue = value;

      if (value) {
        value = this.removeCommaSeparator(value);
        newValue = Number(value)
          .toFixed(decimals)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
      return newValue;
    },
    removeCommaSeparator(value) {
      return value ? value.toString().replace(/,/g, "") : value;
    },
    padRightThreeZeros(value) {
      let returnValue;

      if (!value) {
        returnValue = value;
      } else {
        let valueTemp = this.removeCommaSeparator(value);

        if (valueTemp.length < 4) {
          returnValue = valueTemp + "000";
        } else {
          returnValue = valueTemp;
        }
      }

      return returnValue;
    },
    convertToNumber(value) {
      let returnValue = value;

      if (value && !isNaN(value)) {
        returnValue = Number(value);
      }

      return returnValue;
    },
    isEven(n) {
      return n % 2 === 0;
    },
    isChromeBrowser() {
      const isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor);
      return isChrome;
    },
    getAutoCompleteOff() {
      let autoCompleteOff = "off";
      if (this.isChromeBrowser()) {
        autoCompleteOff = "autocompleteOff";
      }
      return autoCompleteOff;
    },
    mustBeginAndWithBrackets(value) {
      let returnedValue = null;
      let cleanValue = null;

      if (value) {
        cleanValue = value.replace("[", "").replace("]", "");
      }

      if (cleanValue && cleanValue.length > 0) {
        returnedValue = "[" + cleanValue.trim() + "]";
      } else if (value !== null && value !== undefined && value.length === 0) {
        // Catch empty string
        returnedValue = value;
      }

      return returnedValue;
    },
    messageFormatConsolidated(str, replacements) {
      return str.replace(/\{(\d+)\}/g, function() {
        return replacements[arguments[1]];
      });
    }
  }
};
</script>
